// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentBox__container","hover":"ContentBox__hover","triangle":"ContentBox__triangle"};